import styled from 'styled-components';

// Components
import { Typography } from '../../display/Typography';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spaces.s}rem;
  padding: 0.95rem 1rem;
  background-color: ${({ theme }) => theme.colors.white};
  border: 0.1rem solid ${({ theme }) => theme.colors.black};
  border-radius: ${({ theme }) => theme.spaces.xxxs}rem;
  width: 30rem;
`;

export const SmallContainer = styled.div`
  display: flex;
  align-items: end;
  gap: 1rem;
  overflow: hidden;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    align-items: center;
  }
`;

export const Text = styled(Typography)`
  line-height: 1em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.XS};
  }
`;

export const ContainerFileIcon = styled.img``;

export const ContainerRemoveIcon = styled.img`
  height: 1.9rem;
  width: 1.4rem;
  cursor: pointer;
`;
